export default __webpack_public_path__ + "static/media/storycards_logo_white.6fd4de80.svg";